import { useAuthStore } from '../stores/authStore';

// Hook personalizado para esperar a que se complete la hidratación
export const useAuthStoreHydrated = () => {
  return useAuthStore((state) => state.hasHydrated);
};
